import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// MUI defaults to Roboto, which we never load — Mac users fall back to Helvetica,
// Windows users to Arial. Point it at the Inter we do load.
const theme = createTheme({
	typography: { fontFamily: '"Inter", sans-serif' },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		{/* 2. WRAP APP */}
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ThemeProvider>
	</React.StrictMode>,
);
